export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase whitespace-nowrap">
              全网最全免费影视大全
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight">
              屁屁影院
              <span className="block text-primary-600 mt-1">
                高清免费在线观看不缓冲
              </span>
            </h1>

            <p className="mt-3 font-heading text-lg md:text-xl text-foreground-600 font-medium">
              最新大片即点即播，热门经典一网打尽
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              屁屁影院汇聚全球电影大全，从好莱坞商业巨制到独立文艺佳作，从经典老片修复到院线新片速递，十二万部影视作品覆盖200+国家和地区。专业编辑团队7×24小时追踪更新，每日新鲜内容准时上线。无论你是科幻迷、动画党还是纪录片爱好者，这里都是你的专属掌上影院。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-accent-500"></div>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">12万+</strong> 影视作品
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">每日更新</strong> 不间断
                </span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-secondary-500"></div>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">36个节点</strong> 全国秒播
                </span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors text-center"
              >
                开始观影
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:border-foreground-400 hover:text-foreground-950 transition-colors text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-gradient-to-br from-primary-200/40 via-accent-100/30 to-background-200/20 blur-2xl"></div>
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20beam%20with%20floating%20film%20strips%2C%20warm%20golden%20light%20rays%2C%20elegant%20minimal%20composition%2C%20dark%20theater%20background%2C%20dramatic%20lighting%2C%20movie%20cinema%20aesthetic%2C%20artistic%20abstract%20style%2C%20luxurious%20gold%20and%20deep%20charcoal%20tones&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                  alt="屁屁影院 - 高清免费在线观看，电影大全即点即播"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 rounded-xl bg-accent-500/10 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-accent-600 font-bold text-lg leading-none">4K</div>
                  <div className="text-accent-500 text-[10px] font-medium">超清</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}